var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeeklyChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 41,
    viewBox: "0 0 55 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0827 20.4823H35.8174V15.4421H18.8738V20.4823H1.60857C0.720637 20.4823 0 21.2029 0 22.0908V39.3561C0 40.244 0.720637 40.9647 1.60857 40.9647H53.0827C53.9706 40.9647 54.6912 40.244 54.6912 39.3561V22.0908C54.6912 21.2029 53.9706 20.4823 53.0827 20.4823Z",
    fill: "#AC6E4F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.1405,
    width: 54.691,
    height: 6.48877,
    fill: "#8544B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6894 22.0908V39.3561C54.6894 40.244 53.9687 40.9647 53.0808 40.9647H27.3438V15.4421H35.8155V20.4823H53.0808C53.9687 20.4823 54.6894 21.2029 54.6894 22.0908Z",
    fill: "#995B3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7539 17.9213V23.3948C32.7539 24.1261 33.4691 24.719 34.3513 24.719H54.6921V17.9213H32.7539Z",
    fill: "#FFB454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9213V24.719H20.3408C21.223 24.719 21.9382 24.1261 21.9382 23.3948V17.9213H0Z",
    fill: "#FFCA55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60938 28.9542C7.29512 28.9542 11.9042 33.6705 11.9042 39.3562H1.60938V28.9542Z",
    fill: "#AC6E4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4076 40.9648H1.60857C0.720208 40.9648 0 40.2446 0 39.3562V27.4528C7.81473 26.4137 14.4281 33.0812 13.4076 40.9648ZM3.21713 37.7477H10.1492C9.4975 34.1929 6.72584 31.3818 3.21713 30.714V37.7477Z",
    fill: "#FDB953"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7891 39.3562C42.7891 33.6705 47.3981 28.9542 53.0839 28.9542V39.3562H42.7891Z",
    fill: "#995B3D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.083 40.9648H41.284C40.2635 33.0812 46.8769 26.4137 54.6916 27.4528V39.3562C54.6916 40.2446 53.9714 40.9648 53.083 40.9648ZM44.5425 37.7477H51.4746V30.714C47.9658 31.3818 45.1942 34.1929 44.5425 37.7477Z",
    fill: "#FDB953"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 15.4421V25.4141C18.875 30.079 22.5994 33.9481 27.2631 33.9942C32.1572 33.9942 35.8186 30.0877 35.8186 25.5224V15.4421H18.875Z",
    fill: "#FFCA55"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8155 15.4421V25.5224C35.8155 30.1937 32.0161 33.9932 27.3438 33.9942V15.4421H35.8155Z",
    fill: "#FDB953"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9554 22.091V25.5227C28.9554 26.4106 28.2348 27.1312 27.3468 27.1312C26.4589 27.1312 25.7383 26.4106 25.7383 25.5227V22.091C25.7383 21.2031 26.4589 20.4825 27.3468 20.4825C28.2348 20.4825 28.9554 21.2031 28.9554 22.091Z",
    fill: "#8544B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9523 22.091V25.5227C28.9523 26.4106 28.2317 27.1312 27.3438 27.1312V20.4825C28.2317 20.4825 28.9523 21.2031 28.9523 22.091Z",
    fill: "#AD71DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4523 16.7745C27.3287 16.7735 27.205 16.8172 27.1076 16.9058L23.7039 20.0017C23.6018 20.0944 23.5434 20.2247 23.5422 20.3617L23.4863 27.1888C23.4852 27.3269 23.5426 27.4594 23.6449 27.5541L26.9978 30.6559C27.0933 30.7443 27.2151 30.789 27.3375 30.79C27.4597 30.791 27.5822 30.7483 27.6791 30.6615L31.0824 27.615C31.1861 27.522 31.2459 27.3906 31.2471 27.2524L31.303 20.4253C31.3042 20.2884 31.2477 20.1571 31.1472 20.0627L27.7947 16.9114C27.6988 16.8212 27.5757 16.7756 27.4523 16.7745Z",
    fill: "#EFC7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5478 21.0677L25.5025 26.6007L23.4883 27.2278L23.5442 20.4007L25.5478 21.0677Z",
    fill: "#A974CB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2436 26.6243L29.289 21.0913L31.3033 20.4643L31.2473 27.2914L29.2436 26.6243Z",
    fill: "#BC81E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.787 20.3789L24.7309 27.22C24.7298 27.3585 24.7874 27.4912 24.8898 27.586L27.3376 29.8504L27.3297 30.8182C27.2072 30.8172 27.0851 30.7724 26.9894 30.6838L23.6297 27.5756C23.5272 27.4808 23.4696 27.3481 23.4707 27.2096L23.5268 20.3685C23.5279 20.2314 23.5865 20.1008 23.6887 20.0079L27.0994 16.9056C27.197 16.8169 27.321 16.7731 27.4449 16.7741L27.4368 17.7553L24.949 20.0182C24.8466 20.1112 24.7881 20.2417 24.787 20.3789Z",
    fill: "#BC81E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2536 27.2407C31.2524 27.3791 31.1925 27.5109 31.0885 27.604L27.6783 30.6567C27.5812 30.7437 27.4584 30.7865 27.3359 30.7855L27.3566 28.2634L29.2458 26.5722L31.2536 27.2407Z",
    fill: "#D69EF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4336 19.3453L27.4544 16.8133C27.3309 16.8123 27.2071 16.856 27.1097 16.9446L23.706 20.0405C23.6039 20.1332 23.5455 20.2635 23.5443 20.4005L25.548 21.0605L27.4336 19.3453Z",
    fill: "#C18ED8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4863 27.2275C23.4852 27.3657 23.5426 27.4981 23.6449 27.5928L26.9978 30.6946C27.0933 30.783 27.2151 30.8277 27.3375 30.8287L27.3581 28.3118L25.5006 26.5934L23.4863 27.2275Z",
    fill: "#C18ED8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4322 19.3454L27.4529 16.8134C27.5763 16.8144 27.6995 16.8601 27.7953 16.9503L31.1478 20.1015C31.2483 20.1959 31.3048 20.3272 31.3036 20.4641L29.2893 21.0912L27.4322 19.3454Z",
    fill: "#BC81E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4313 0H11.26C5.04124 0 0 5.04124 0 11.26V15.4422C0 15.4422 4.16833 13.8337 27.3456 13.8337C50.5229 13.8337 54.6912 15.4422 54.6912 15.4422V11.26C54.6912 5.04124 49.65 0 43.4313 0Z",
    fill: "#AC6E4F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6894 11.26V15.4422C54.6894 15.4422 50.521 13.8337 27.3438 13.8337V0H43.4294C49.6481 0 54.6894 5.04124 54.6894 11.26Z",
    fill: "#995B3D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2108 13.8334H20.4844C20.4844 10.0425 23.5567 6.97018 27.3476 6.97018C31.1384 6.97018 34.2108 10.0425 34.2108 13.8334Z",
    fill: "#AC6CDC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.207 13.8334H27.3438V6.97018C31.1346 6.97018 34.207 10.0425 34.207 13.8334Z",
    fill: "#8544B7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.664 13.1522C34.9102 9.24763 31.4668 6.28894 27.3456 6.28894C23.2245 6.28894 19.7811 9.24763 19.0272 13.1522H0V16.3693H54.6912V13.1522H35.664ZM22.343 13.1522C23.0239 11.0385 25.0089 9.50607 27.3456 9.50607C29.6823 9.50607 31.6673 11.0385 32.3482 13.1522H22.343Z",
    fill: "#FFCA55"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6894 13.1522V16.3693H27.3438V13.1522H32.3464C31.6654 11.0385 29.6805 9.50607 27.3438 9.50607V6.28894C31.4649 6.28894 34.9083 9.24763 35.6622 13.1522H54.6894Z",
    fill: "#FDB953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyChest);
export default __webpack_public_path__ + "static/media/weeklyChest.825ce16dd11cb00f59a2587e61a5db53.svg";
export { ForwardRef as ReactComponent };